<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <div style="  width: 100%" class="row justify-between q-pb-xs items-center">
      <span>{{ getTitle() }}</span>
      <span v-if="!formProperty.readonly && !readOnly">
          <q-btn unelevated @click="clear()">Zurücksetzen</q-btn>
        </span>
    </div>
    <img v-if="signExists" :src="formProperty.blobAsString" style="width:100%;border:rgb(200, 200, 200) 1px solid;border-radius: 5px;opacity: 0.5"/>
    <vue-signature-pad v-else
                       :ref="formProperty.nativename"
                       :id="formProperty.nativename"
                       :options="{ onBegin, onEnd }"
                       :customStyle="{ border: 'rgb(200, 200, 200) 1px solid', height: '130px', 'border-radius':'5px' }"
    />
    <span v-if="propertyHasError" style="color: red">{{ getErrorLabel() }}</span>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {requiredIf} from '@vuelidate/validators'
import {fldComponentsMixin} from './mixins/fldComponent'
import {getValueOrCleanNull} from "./formsHelper";
import {StaticData} from 'src/classes/StaticData'
import moment from 'moment'

export default {
  mixins: [fldComponentsMixin],
  props: [
    'formProperty',
    'queryID',
    'volatile',
    'readOnly'
  ],
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      value: this.getValue(),
      signExists: false
    }
  },
  computed: {
    propertyHasError() {
      return (this.v$.value.$error && !this.v$.$errors.map(err => err.$validator).includes('requiredIf')) || this.formProperty.invalid
    }
  },
  validations() {
    return this.getValidations()
  },
  watch: {
    value: function () {
      this.formProperty.value = getValueOrCleanNull(this.value, this.formProperty)
    }
  },
  methods: {
    getValidations() {
      let result = {value: {}}
      result.value['requiredIf'] = requiredIf(() => {
        if (this.formProperty.masterPropertyMode == StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          return (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency == true
        } else {
          return this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY
        }
      })
      return result
    },
    onBegin() {
      this.$refs[this.formProperty.nativename].resizeCanvas()
    },
    onEnd() {
      const {isEmpty, data} = this.$refs[this.formProperty.nativename].saveSignature();
      if (!isEmpty) {
        this.formProperty.invalid = false
        this.v$.$touch()
        this.value = this.formProperty.nativename + "_signature_" + moment().format("YYYY-MM-DD_HH:mm:ss") + ".jpg"
        this.formProperty.value = this.value
        this.formProperty.blobAsString = data
        this.$emit('onChange', {
          classID: this.formProperty.classID,
          parentClassID: this.formProperty.parentFormPointer?.classID,
          nativename: this.formProperty.nativename,
          deleteDependentFields: false,
          value: this.value
        })  // send onChange event to parent (formular or parameter)
        if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
          this.eventBus.formularEdited()
        }
      }
    },
    clear() {
      this.value = null
      this.formProperty.blobAsString = null
      this.formProperty.value = null

      if (!this.signExists) {
        this.$refs[this.formProperty.nativename].clearSignature()
      }

      this.signExists = false
      this.formProperty.invalid = false
      this.v$.$touch()
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: this.value
      })  // send onChange event to parent (formular or parameter)
      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }
    },
    getValue() {
      let result = this.formProperty.value ? this.formProperty.value : this.formProperty.defaultValue
      this.formProperty.value = result
      return result
    },
    getErrorLabel() {
      let result = ""
      const errors = this.v$.$errors.map(err => err.$validator)
      if (errors.includes("requiredIf")) {
        result = this.formProperty.infoRequired && this.formProperty.infoRequired != "" ? this.formProperty.infoRequired : "Feld muss befüllt werden."
      }
      return result
    }
  },
  mounted: function () {
    this.formProperty.validate = () => {
      this.v$.$reset()
      this.v$.$touch()
      this.formProperty.invalid = this.v$.value.$error
      this.formProperty.errorMsg = this.getErrorLabel()

      if (this.formProperty.errorFetchingData !== "") {
        this.formProperty.errorMsg = this.formProperty.errorFetchingData
        this.formProperty.invalid = true
      }
    }

    this.formProperty.setValid = () => {
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$touch()
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }

    if (this.formProperty.blobAsString != null && this.formProperty.blobAsString !== "") {
      this.signExists = true
    }

    if (this.formProperty.readonly || this.readOnly) {
      this.$refs[this.formProperty.nativename].lockSignaturePad()
    }

    if (!this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: this.value
      })
    }
  }
}
</script>

<style lang="sass">
.q-field-label
  font-weight: bold

.r_field
  padding: 5px

  .r_title
    font-size: 12px
    display: block

  .r_error
    color: var(--q-color-negative)
    font-size: 12px
    line-height: 1
</style>
